import gsap from 'gsap'
import Component from '../classes/Component'

export default class extends Component {
  constructor () {
    super({
      classes: {},
      element: '.portrait-view',
      elements: {
        title: 'h2',
        lowerTitle: 'h3',
        background: '.portrait-view__background'
      }
    })

    this.create()
  }

  create () {
    this.timeline = gsap.timeline({
      repeat: -1
    })
      .to(this.elements.background, {
        width: '57vw',
        height: '100vw',
        duration: 1,
        rotate: '-90deg',
        ease: 'expo.inOut'
      })
      .to([this.elements.title, this.elements.lowerTitle], {
        color: 'white',
        duration: 1,
        ease: 'expo.inOut'
      }, '-=1')
      .to({}, {
        duration: 2
      })
  }

  onResize () {

  }
}
